import { useQuery } from '@apollo/client'
import { totalNFTBuyerClient, totalDailyContractInteractionClient } from 'apollo/client'
import gql from 'graphql-tag'
import { useMemo } from 'react'
import { notEmpty } from 'utils'

export const QUERY_DAILY_CONTRACT_INTERACTIONS = gql`
  query records { 
    records {
        date_time
 contract_interactions
    }
  }
  
`

interface DailyNFTContractInteractionResponse {
    records: {
        date_time: string
        contract_interactions: number
    }[]
}

/**
 * Fetch Daily NFT Active Collections/ Active Contracts/ Contract Interactions
 */

export function useDailyNFTContractInteractions(): {
    loading: boolean
    error: boolean,
    records: { dateTime: string, nFTContractInteractionCount: number }[] | undefined
} {
    const { loading, error, data } = useQuery<DailyNFTContractInteractionResponse>(QUERY_DAILY_CONTRACT_INTERACTIONS, {
        client: totalDailyContractInteractionClient,
        fetchPolicy: 'cache-first',
    })
    const formattedData = useMemo(() => {
        if (data) {
            return data.records
                .map((p) => {
                    return {
                        dateTime: p.date_time,
                        nFTContractInteractionCount: p.contract_interactions
                    }
                })
                .filter(notEmpty)
        } else {
            return undefined
        }
    }, [data])

    return {
        loading: loading,
        error: Boolean(error),
        records: formattedData,
    }
}
